import HeadingSection from './HeadingSection'

export default HeadingSection
